<template lang="html">
  <div>
    <Modal class="modal" v-model="info_visible" width="380" footer-hide class-name="vertical-center-modal" @on-visible-change="haddleChangeModal">
      <div class="flow-path-1" :class="{'show':this.flow_path == 1}" v-if="this.flow_path == 1">
        <Form :model="form_data" label-position="top">
          <p class="p">填写信息</p>
          <FormItem label="姓名" class="req">
            <Input v-model="form_data.name" autocomplete="off" placeholder="请输入姓名"></Input>
          </FormItem>
          <FormItem label="公司" class="req">
            <Input v-model="form_data.comp_name" autocomplete="off" placeholder="请输入公司名称"></Input>
          </FormItem>
          <FormItem label="职位" class="req">
            <Input v-model="form_data.title" autocomplete="off" placeholder="请输入职位"></Input>
          </FormItem>
          <FormItem label="手机号" class="req">
            <Input autocomplete="off" placeholder="请输入手机号" :value="user.mobile" disabled></Input>
          </FormItem>
          <FormItem label="微信号">
            <Input v-model="form_data.weixin" autocomplete="off" placeholder="请输入微信号"></Input>
          </FormItem>
          <FormItem label="邮箱">
            <Input v-model="form_data.email" autocomplete="off" placeholder="请输入邮箱"></Input>
          </FormItem>
        </Form>
        <div class="button" @click="goPath2">
          确定
        </div>
        <div class="message-valid" v-show="show_req">
          {{req_text}}
        </div>
      </div>
      <!-- 流程2 -->
      <div class="flow-path-2" :class="{'show':this.flow_path == 2}" v-if="this.flow_path == 2">
        <p class="p">确认订单信息</p>
        <p class="info-p"><span>开通账号</span><span>{{user.mobile}}</span></p>
        <p class="info-p"><span>购买服务</span><span>{{buy_text}}</span></p>
        <p class="info-p" v-if="buytype == '8' || buytype == '13'"><span>到期时间</span><span>{{deadLineDay(select_obj)}}</span></p>
        <!-- <p class="info-p" v-if=""><span>折扣优惠</span><span>300</span></p> -->
        <div class="select-area">
          <p>{{buytype == '8'?'选择服务':'支付金额'}}</p>
          <div class="select-list">
            <div :class="{'active': select_obj.id == item.id}" v-for="(item, index) in pricearr" :key="index" @click="handleSelectObj(item)">
              <p> <span>￥</span><span>{{item.price}}</span><span v-if="item.remark">{{item.remark}}</span> </p>
              <img :src="$store.state.static_img_url + 'pic/buyvip/tuijian.png'" v-if="index == 0 && buytype == '8'">
              <img :src="$store.state.static_img_url + 'pic/buyvip/new.png'" v-if="index == 3 && buytype == '8'">
            </div>
          </div>
        </div>
        <div class="pay-info">
          <div class="">
            <div>优惠券</div>
            <div>
              <Select v-model="coupon_id" v-if="coupon_list.length > 0" placeholder="不使用">
                <Option v-for="item in coupon_list" :value="item.id" :key="item.id">-￥{{item.amount_value}}</Option>
                <Option value="" key="null">不使用</Option>
              </Select>
              <span v-else>无可用</span>
            </div>
          </div>
          <div class="">
            <div>实付金额</div>
            <div>￥{{show_amount}}</div>
          </div>
        </div>
        <div class="pay-way">
          <div>
            <div class="left">
              <img :src="$store.state.static_img_url + 'pic/buyvip/wepay.png'">
              <span>微信支付</span>
            </div>
            <div class="right">
              <div class="right-in">
              </div>
            </div>
          </div>
        </div>
        <div class="button" @click="goPath3">
          {{buytype == '8' ? '成为会员':'立即购买'}}
        </div>
      </div>
      <!-- 流程3 -->
      <div class="flow-path-3" :class="{'show':this.flow_path == 3}" v-if="this.flow_path == 3">
        <p class="p">支付订单</p>
        <!-- <img :src="wx_pay_url" v-if="wx_pay_url"> -->
        <p class="p0">完成支付后可在<span>我的-订单管理</span>中申请发票
          <br/>{{buytype == '8'?'VIP会员自支付完成之时起5分钟内生效':''}}
        </p>
        <div class="share-img" v-show="wx_pay_url">
        </div>
        <img :src="$store.state.static_img_url + 'pic/buyvip/loading.gif'" v-show="!wx_pay_url">
        <p class="p1">实际付款</p>
        <p class="p2"> <span>￥</span> <span>{{select_obj.price ? (show_amount) : flowprice}}</span> </p>
        <p class="p3"> <i class="iconfont">&#xe636;</i> <span>请使用微信扫一扫<br/>扫描二维码支付</span> </p>
        <p class="p4">温馨提示：动脉橙会员是虚拟产品，暂不接受退款</p>
        <!-- <div class="button" @click="goPath4">
          已完成支付
        </div> -->
      </div>
      <!-- 流程4 -->
      <div class="flow-path-4" :class="{'show':this.flow_path == 4}" v-if="this.flow_path == 4">
        <p class="p">支付结果</p>
        <div class="flow-div">
          <div class="item">
            <div class="circle one">
              <i class="iconfont">&#xe67f;</i>
            </div>
            <div>
              <p class="p1">支付成功</p>
              <p class="p2" v-if="buytype == '8'"><span>您已成功购买VIP会员</span></p>
              <p class="p2" v-if="buytype == '1'"><span>您已成功购买报告</span><br /><span class="name">{{buy_text}}</span></p>
              <p class="p2" v-if="buytype == '13'"><span>您已成功购买</span><br /><span class="name">{{buy_text}}</span></p>
            </div>
          </div>
          <div class="item" v-if="new_coupon.length > 0">
            <div class="circle two">
              <i class="iconfont">&#xe680;</i>
            </div>
            <div>
              <p class="p3 p1">恭喜您，获得{{new_coupon[0].amount_value}}元优惠券</p>
              <p class="p2">
                有效期至:{{new_coupon[0].effective_time.split(' ')[0]}}
                可购买平台服务
                <br>您可以在<router-link to="/userCoupon">个人中心-我的优惠券</router-link>查看</p>
            </div>
          </div>
          <div class="item">
            <div class="circle three">
              <i class="iconfont">&#xe6e8;</i>
            </div>
            <div>
              <p class="p4 p1">添加动脉网客服，动脉智库7天免费用</p>
              <img :src="$store.state.static_img_url+'pic/buyvip/pay-tip.jpg'">
            </div>
          </div>
        </div>
        <div class="button" @click="go">
          关闭
        </div>
        <!-- <img :src="$store.state.static_img_url + 'pic/buyvip/yes.png'">
        <p class="p1">支付成功</p>

        <p class="p2" v-if="buytype == '8'"><span>您已成功购买VIP会员</span></p>
        <p class="p2" v-if="buytype == '1'"><span>您已成功购买报告</span><br /><span class="name">{{buy_text}}</span></p>
        <p class="p2" v-if="buytype == '13'"><span>您已成功购买</span><br /><span class="name">{{buy_text}}</span></p>
        <template v-if="new_coupon.length > 0">
          <div class="new_coupon">恭喜您，获得{{new_coupon[0].amount_value}}元优惠券</div>
          <div class="new_coupon_p">30天有效期，用于购买平台服务<br>您可以在<router-link to="/userCoupon">个人中心-我的优惠券</router-link>查看</div>
        </template>
        <p class="p2 p3" v-if="buytype == '1' || buytype == '13'">使用过程中有任何疑问<br />请联系客服电话：023-67139735</p>

        <div class="button" @click="go">
          关闭
        </div> -->
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment'
import Cookies from 'js-cookie'
// import axios from 'axios'
import {updateUserInfo, createVipOrder, vipPayUrl, checkOrderPaid, createReportOrder, reportPayUrl, refreshUserInfo, createThemeTypePayUrl, createThemeTypeOrder, couponList} from '../service'
export default {
  data() {
    return {
      info_visible:false,
      show_req: false, // 必填提示框
      req_text: '',
      flow_path: 1, // 流程
      buy_text: '', // 购买的东西叫什么
      form_data: {
        user_key: this.$store.state.user_key,
        name: '',
        title: '',
        comp_name: '',
        weixin: '',
        email: ''
      },
      new_coupon: [],
      coupon_list: [],
      coupon_id: '',
      select_obj: {}, // 已选择的类型的对象
      order_uid: '', // 订单uid
      wx_pay_url: '', // 微信支付二维码连接

      checkPayInterval: '', // 检查订单定时器
      // timeInterval: '', // 时间定时器
      // time_interval: 5,
      cb: ''
    }
  },
  props: ['buytype', 'pricearr', 'orderuid', 'flowprice'], // 购买类型(8是会员，1是报告, 13是专题), 价格数组, 订单uid(在待支付列表时直接获取), flowprice(应付价格，流程3用)
  computed: {
    user_key() {
      return this.$store.state.user_key
    },
    user() {
      if (this.$store.state.user && typeof this.$store.state.user == 'string') {
        return JSON.parse(this.$store.state.user)
      } else {
        return this.$store.state.user
      }
    },
    show_amount() {
      if(this.coupon_id) {
        let item = this.coupon_list.find((a) => this.coupon_id == a.id)
        let amount = Number(this.select_obj.price) - Number(item.amount_value)
        return Math.round(amount*10000)/10000
      } else {
        return this.select_obj.price
      }
    }
  },
  methods: {
    showInfo(flow_path, buy_text, cb) { // 1是填信息，2是确认支付信息，3是二维码支付，4是支付状态
      // console.log(this.pricearr)
      this.info_visible = !this.info_visible
      this.flow_path = flow_path
      this.buy_text = buy_text
      if (cb) {
        this.cb = cb
      }
      if (this.flow_path == 3) {
        this.order_uid = this.orderuid
        if (this.buytype == '8') {
          this.vipPayUrl()
        } else {
          this.reportPayUrl()
        }
      }
    },
    async goPath2() { // 前往订单详情(流程2)
      if (!this.form_data.name || !this.form_data.comp_name || !this.form_data.title) {
        this.req_text = '带*的选项为必填项，请完善信息'
        this.show_req = true
        setTimeout(() => { this.show_req = false }, 2000)
        return
      }
      let reg = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (this.form_data.email) {
        if (!(reg.test(this.form_data.email))) {
          this.req_text = '邮箱格式不正确'
          this.show_req = true
          setTimeout(() => { this.show_req = false }, 2000)
          return
        }
      }
      let res = await updateUserInfo(this.form_data, (error) => { this.$Message.error('信息修改失败!') })
      if(res.status == 'success') {
        this.user.name = this.form_data.name
        this.user.title = this.form_data.title
        this.user.compName = this.form_data.comp_name
        this.user.email = this.form_data.email
        this.user.weixin = this.form_data.weixin
        // localStorage.user = JSON.stringify(this.user)
        // Cookies.set('user', this.user)
        this.$store.commit('updateUser', this.user)
        this.flow_path = 2
      } else {
        this.$Message.error(res.message)
      }
    },
    deadLineDay(select_obj) { // 截止日期
      if (this.buytype == '8') {
        let end_time
        if (this.user.vip_end_time) {
          end_time = moment(this.user.vip_end_time)
        } else {
          end_time = moment()
        }
        if (select_obj.type == 1) {
          return end_time.add(2, 'years').format('YYYY-MM-DD')
        } else if(select_obj.type == 2) {
          return end_time.add(1, 'years').format('YYYY-MM-DD')
        } else if(select_obj.type == 3) {
          return end_time.add(1, 'months').format('YYYY-MM-DD')
        } else if(select_obj.type == 4) {
          return end_time.format('YYYY-MM-DD')
        }
      } else if (this.buytype == '13') {
        return moment().add(1, 'years').format('YYYY-MM-DD')
      }
    },
    async goPath3() { // 前往支付二维码(流程3)，此时订单已经生成
      let res
      // console.log(this.select_obj)
      if (this.buytype == '8') {
        res = await createVipOrder({
          user_key: this.$store.state.user_key,
          uid: this.select_obj.uid,
          recieve_coupon_id: this.coupon_id
        }, (err) => { this.$Message.error('创建订单失败') })
      } else if(this.buytype == '1'){
        res = await createReportOrder({
          user_key: this.$store.state.user_key,
          uid: this.select_obj.uid,
          recieve_coupon_id: this.coupon_id
        }, (err) => { this.$Message.error('创建订单失败') })
      } else if(this.buytype == '13'){
        res = await createThemeTypeOrder({
          user_key: this.$store.state.user_key,
          theme_type_id: this.select_obj.type_arr[0],
          recieve_coupon_id: this.coupon_id
        }, (err) => { this.$Message.error('创建订单失败') })
      }
      if (res.status == 'success') {
        this.flow_path = 3
        this.order_uid = res.order_uid
        if (this.buytype == '8') {
          this.vipPayUrl()
        } else if(this.buytype == '1'){
          this.reportPayUrl()
        } else if(this.buytype == '13'){
          this.themePayUrl()
        }
      } else {
        this.$Message.error(res.message)
      }
    },
    async vipPayUrl() { // 当流程走到3的时候，请求(会员)支付连接
      let res = await vipPayUrl({
        user_key: this.$store.state.user_key,
        uid: this.order_uid
      }, (err) => { this.$Message.error('生成支付二维码失败') })
      if (res.status == 'success') {
        this.wx_pay_url = res.url
        jQuery($('.share-img').html('').qrcode({
          text: res.url,
          width: 155,
          height: 155
        }))
        this.checkPayInterval = setInterval(()=> { // 检查是否支付的定时器
          this.checkOrderPaid()
        }, 1000)
      } else {
        this.$Message.error(res.message)
      }
    },
    async reportPayUrl() { // 当流程走到3的时候，请求(报告)支付连接
      let res = await reportPayUrl({
        user_key: this.$store.state.user_key,
        uid: this.order_uid
      }, (err) => { this.$Message.error('生成支付二维码失败') })
      if (res.status == 'success') {
        this.wx_pay_url = res.url
        jQuery($('.share-img').html('').qrcode({
          text: res.url,
          width: 155,
          height: 155
        }))
        this.checkPayInterval = setInterval(()=> { // 检查是否支付的定时器
          this.checkOrderPaid()
        }, 1000)
      } else {
        this.$Message.error(res.message)
      }
    },
    async themePayUrl() { // 当流程走到3的时候，请求(报告)支付连接
      let res = await createThemeTypePayUrl({
        user_key: this.$store.state.user_key,
        uid: this.order_uid
      }, (err) => { this.$Message.error('生成支付二维码失败') })
      if (res.status == 'success') {
        this.wx_pay_url = res.url
        jQuery($('.share-img').html('').qrcode({
          text: res.url,
          width: 155,
          height: 155
        }))
        this.checkPayInterval = setInterval(()=> { // 检查是否支付的定时器
          this.checkOrderPaid()
        }, 1000)
      } else {
        this.$Message.error(res.message)
      }
    },
    async checkOrderPaid() { // 检查订单支付状态
      let res = await checkOrderPaid({
        user_key: this.$store.state.user_key,
        uid: this.order_uid,
        type: this.buytype
      }, (err) => { this.$Message.error('订单状态检查失败，请手动确认') })
      if (res.status == 'success') {
        if (res.res == 1) {
          if(this.buytype == '8') {
            let user_info = await refreshUserInfo({user_key: this.user_key}, (error) => {
              this.$Message.error('用户信息更新失败，请刷新')
            })
            if (user_info.status == 'success') {
              this.$store.commit('updateUser', user_info.res[0])
            }
          }
          this.$set(this.$data, 'new_coupon', res.coupon)
          clearInterval(this.checkPayInterval)
          this.goPath4()
        }
      } else {
        this.$Message.error(res.message)
      }
    },
    goPath4() { // 前往支付状态页面（成功还是失败）
      jQuery($('.share-img').html(''))
      this.flow_path = 4
      // if (this.buytype == '8') {
      //   this.timeInterval = setInterval(() => { // 倒计时的定时器
      //     this.time_interval--
      //     if (this.time_interval == 0) {
      //       clearInterval(this.timeInterval)
      //       this.info_visible = false
      //       this.$router.replace({name: 'NewsList'})
      //     }
      //   }, 1000)
      // }
    },
    go() { // 返回首页和查看报告
      // if (this.buytype == '8') {
      //
      // } else {
      //   this.$router.replace({name: 'NewsList'})
      // }
      this.info_visible = false
    },
    handleSelectObj(item) {
      this.select_obj = item
      this.coupon_id = ''
      this.coupon_list = []
      this.getCouponList(item.price)
    },
    haddleChangeModal(val) {
      if(this.flow_path == 4 && !val) {
        if (this.cb) {
          this.cb()
        }
      }
    },
    async getCouponList(value) {
      let res = await couponList({
        user_key: this.$store.state.user_key,
        status: '1',
        is_effective: '1',
        order_type: '1',
        amount_value: Math.round(value*100) / 100
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'coupon_list', res.res)
        // this.$set(this.$data, 'new_coupon', res.res)
        this.coupon_id = res.res.length > 0 ? res.res[0].id : ''
      } else {
        this.$Message.error(res.message)
      }
    }
  },
  watch: {
    info_visible(val) { // 模态框的显示与关闭
      if (val) { // 显示
        this.form_data.name = this.user.name
        this.form_data.title = this.user.title
        this.form_data.comp_name = this.user.compName
        this.form_data.email = this.user.email
        this.form_data.weixin = this.user.weixin
        this.select_obj = (this.flow_path == 4 || this.flow_path == 3) ? {}:this.pricearr[0]

        this.getCouponList(this.select_obj.price)
      } else { // 关闭
        if(this.flow_path == 4 || this.flow_path == 3) {
          clearInterval(this.checkPayInterval)
          // clearInterval(this.timeInterval)
          jQuery($('.share-img').html(''))
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
button()
  height:40px;
  background: rgba(250, 122, 80, 1);
  border-radius:4px;
  line-height: 40px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  &:hover
    background: #FF9A79;
.modal
  >>>.vertical-center-modal
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal
      top: 0
  >>>.ivu-modal-body
    padding: 20px;
    line-height: 1.2;
  >>>.ivu-icon-ios-close
    color: #d5d5d5;
    &:hover
      color: rgba(250, 122, 80, 1)
.flow-path-1,.flow-path-2,.flow-path-3,.flow-path-4
  transition: all .3s;
  opacity: 0;
  &.show
    opacity: 1;
.p
  color: #333333;
  font-size: 16px;
  font-weight: bold;
.flow-path-1
  position: relative;
  .p
    margin-bottom: 18px;
  form
  >>> .ivu-form-item-label
    font-size: 14px;
    color: #333333;
  >>>.ivu-form-item
    margin-bottom: 16px;
    &.req
      .ivu-form-item-label:after
        color: rgba(250, 122, 80, 1);
        content: '*';
        margin-left: 4px;
    .ivu-input
      padding: 9px 10px;
  .button
    margin-top: 4px;
    button();
  .message-valid
    width: 260px;
    text-align: center;
    padding: 15px 26px;
    background: #000000;
    opacity:0.5;
    border-radius:6px;
    position: absolute;
    top: 200px;
    left: 50%;
    transform: translateX(-130px);
    margin: 0 auto;
    color: #ffffff;
    font-size: 14px;
.flow-path-2
  .p
    margin-bottom: 16px;
  .info-p
    font-size: 14px;
    color: #333333;
    span+span
      margin-left: 20px;
    &+.info-p
      margin-top: 16px;
  .select-area
    margin-top: 10px;
    padding-top: 14px;
    border-top: 1px solid #e9e9e9;
    >p
      font-size:14px;
      color: #333333;
      margin-bottom: 14px;
      font-weight: bold;
    .select-list
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 10px;
      >div
        height:50px;
        border:1px solid #e9e9e9;
        border-radius:6px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &.active
          border:1px solid rgba(250, 122, 80, 1);
          background: #fffaf5;
          p
            span:nth-child(1)
              color: rgba(250, 122, 80, 1);
            span:nth-child(2)
              color: rgba(250, 122, 80, 1);
            span:nth-child(3)
              color: #333333;
        p
          color: #999999;
          font-size: 14px;
          span:nth-child(2)
            font-size: 24px;
          span:nth-child(4)
            text-decoration: line-through;
            font-size: 12px;
            margin-left: 4px;
        img
          width: 46px;
          height: 20px;
          position: absolute;
          top: -7px;
          right: -1px;
  .pay-info
    margin-top: 16px;
    > div
      display: flex
      &+div
        margin-top: 6px
      > div:first-of-type
        flex: 0 0 70px
        line-height: 32px
      > div:last-of-type
        flex: auto
        line-height: 32px
        >>> .ivu-select
          width: 95px
        >>> .ivu-select-selection
          height: 32px
          border-color: #e9e9e9
        >>> .ivu-select-selected-value
        >>> .ivu-select-placeholder
          color: #333
          height: 32px
          line-height: 32px
  .pay-way
    margin-top: 14px;
    padding-bottom: 14px;
    border-bottom: 1px solid #eaeaea;
    >p
      margin-bottom: 20px;
      color: #333333;
      font-size: 14px;
      font-weight: 500;
    >div
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left
        img
          vertical-align: middle;
        span
          color: #333333;
          font-size: 14px;
          font-weight: 500;
          margin-left: 6px;
          vertical-align: middle;
      .right
        width: 16px;
        height: 16px;
        border-radius:50%;
        border:1px solid rgba(250, 122, 80, 1);
        position: relative;
        &-in
          width: 8px;
          height: 8px;
          border-radius:50%;
          background: rgba(250, 122, 80, 1);
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-4px, -4px);
  .button
    margin-top: 20px;
    button();
.flow-path-3
  >img
    margin: 30px auto 0;
    width: 155px;
    height: 155px;
    display: block;
    border: 1px solid #999999;
  .share-img
    text-align: center;
    margin: 30px auto 0;
  .p0,.p1,.p2,.p3,.p4
    text-align: center;
  .p0
    margin-top: 30px;
    color: #333333;
    font-size: 12px;
    line-height: 20px;
    span
      color: #FA7A50;
  .p1
    margin-top: 20px;
    color: #333333;
    font-size: 16px;
    font-weight: 500;
  .p2
    margin-top: 10px;
    font-size: 24px;
    color: rgba(250, 122, 80, 1);
    span
      vertical-align: baseline;
    span:nth-child(1)
      font-size: 14px;
      margin-right: 4px;
  .p3
    margin-top: 20px;
    font-size: 12px;
    color: #999999;
    display: flex;
    justify-content: center;
    align-items: center;
    i
      font-size: 30px;
      margin-right: 10px;
    span
      text-align: left;
  .p4
    font-size: 12px;
    color: #999999;
    margin-top: 28px;
    margin-bottom: 20px;
  .button
    margin-top: 20px;
    button()
.flow-path-4
  .flow-div
    padding: 30px 20px 30px 40px;
    .item
      border-left: 6px solid #6BDF57;
      padding-left: 40px;
      position: relative;
      height: 120px;
      &:nth-last-child(1)
        padding-bottom: 0;
        border-color: transparent
      .circle
        position: absolute;
        left: 0;
        top: 0;
        transform: translateX(calc(-50% - 3px));
        background: linear-gradient(-45deg,rgba(102,221,85,1) 0%,rgba(132,232,96,1) 100%);
        border-radius:50%;
        color: #fff;
        text-align: center;
        &.one
          width: 46px;
          height: 46px;
          line-height: 46px;
          i
            font-size: 42px;
        &.two
          width: 40px;
          height: 40px;
          line-height: 40px;
          i
            font-size: 28px;
        &.three
          width: 30px;
          height: 30px;
          line-height: 30px;
          i
            font-size: 18px;
      .p1
        color: #333333;
        font-size: 24px;
        font-weight: bold;
        line-height:28px;
      .p2
        color: #999999;
        font-size: 14px;
        line-height:22px;
      .p3
        font-size: 18px;
      .p4
        font-size: 14px;
      img
        width: 70px;
        height: 70px;
  // img
  //   display: block;
  //   margin: 36px auto 20px;
  // .p1
  //   font-size: 24px;
  //   font-weight: bold;
  //   color: #333333;
  //   text-align: center;
  //   margin-bottom: 6px;
  //   line-height: 1;
  // .p2
  //   font-size: 14px;
  //   color: #333333;
  //   text-align: center;
  //   .name
  //     font-weight:bold;
  // .p3
  //   margin-top: 40px;
  //   span
  //     color: #FC3B3B;
  // .new_coupon
  //   width:203px;
  //   height:28px;
  //   background-image: url('~pic/coupon/tips_pc.png')
  //   background-size: 203px 28px
  //   line-height: 28px
  //   font-size:14px;
  //   color:rgba(165,129,84,1);
  //   text-align: center
  //   margin: 10px auto
  // .new_coupon_p
  //   color:rgba(153,153,153,1);
  //   font-size:12px;
  //   line-height:18px;
  //   margin-top:6px;
  //   text-align: center;
  //   a
  //     color: #188DED;
  .button
    button()
</style>
